/**
//================================================================================
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:dialogUtility
//
// <<Modification History>>
// Version  | Date       | Updated By            | Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2021/08/17 | 富士通株式会社        | 新規作成
// 01.01.00 | 2022/06/28 | 富士通Japan株式会社   | 令和4年度改修対応（8月リリース）
// 01.02.00 | 2024/09/17 | 富士通Japan株式会社   | 令和6年度改修対応（1次リリース）
//================================================================================
 */
import store from '@/store/store.js';

import { DIALOG_BUTTON_LIST_KEY, DIALOG_KIND } from '@/const/const.js';
import { STORE_DIALOG_MESSAGE, STORE_DIALOG_BUTTON_LIST, STORE_DIALOG_FOCUS_KEY, STORE_DIALOG_CALL_BACK,
			STORE_DIALOG_DIALOG_FLG,STORE_DIALOG_KIND, STORE_DIALOG_LINK_FLG
		} from '@/const/store.js';

/* 完了ダイアログ
 * @param {String} message 出力するメッセージ
 * @param {Object} callback コールバック関数
 */
export function co_completedDialog(message, callback) {
	
	let buttonList = [
		{'key':DIALOG_BUTTON_LIST_KEY.OK, 'label':'はい'}
	];

	// メッセージ、ボタン、フォーカス、コールバック関数、メッセージ種類、リンクフラグの設定
	store.commit(STORE_DIALOG_MESSAGE, message);
	store.commit(STORE_DIALOG_BUTTON_LIST, buttonList);
	store.commit(STORE_DIALOG_FOCUS_KEY, DIALOG_BUTTON_LIST_KEY.OK);
	store.commit(STORE_DIALOG_CALL_BACK, callback);
	store.commit(STORE_DIALOG_KIND, DIALOG_KIND.NOTICE);
	store.commit(STORE_DIALOG_LINK_FLG, false);

	// ダイアログを呼び出す
	store.commit(STORE_DIALOG_DIALOG_FLG, true);
}

/* 確認用ダイアログ
 * @param {String} message 出力するメッセージ
 * @param {Object} callback コールバック関数
 */
export function co_confirmDialog(message, callback) {

	let buttonList = [
		{'key':DIALOG_BUTTON_LIST_KEY.OK, 'label':'はい'},
		{'key':DIALOG_BUTTON_LIST_KEY.CANCEL, 'label':'いいえ'}
	];

	// メッセージ、ボタン、フォーカス、コールバック関数、メッセージ種類、リンクフラグの設定
	store.commit(STORE_DIALOG_MESSAGE, message);
	store.commit(STORE_DIALOG_BUTTON_LIST, buttonList);
	store.commit(STORE_DIALOG_FOCUS_KEY, DIALOG_BUTTON_LIST_KEY.OK);
	store.commit(STORE_DIALOG_CALL_BACK, callback);
	store.commit(STORE_DIALOG_KIND, DIALOG_KIND.CONFIRM);
	store.commit(STORE_DIALOG_LINK_FLG, false);

	// ダイアログを呼び出す
	store.commit(STORE_DIALOG_DIALOG_FLG, true);
}

/* 確認用ダイアログ２
 * @param {String} message 出力するメッセージ
 * @param {Object} callback コールバック関数
 */
export function co_confirmDialog2(message, callback) {

	let buttonList = [
		{'key':DIALOG_BUTTON_LIST_KEY.OK, 'label':'はい'}
	];

	// メッセージ、ボタン、フォーカス、コールバック関数、メッセージ種類、リンクフラグの設定
	store.commit(STORE_DIALOG_MESSAGE, message);
	store.commit(STORE_DIALOG_BUTTON_LIST, buttonList);
	store.commit(STORE_DIALOG_FOCUS_KEY, DIALOG_BUTTON_LIST_KEY.OK);
	store.commit(STORE_DIALOG_CALL_BACK, callback);
	store.commit(STORE_DIALOG_KIND, DIALOG_KIND.CONFIRM);
	store.commit(STORE_DIALOG_LINK_FLG, false);

	// ダイアログを呼び出す
	store.commit(STORE_DIALOG_DIALOG_FLG, true);
}

/* 確認用ダイアログ（フォーカス可変）
 * @param {String} message 出力するメッセージ
 * @param {String} focuskey フォーカス
 * @param {Object} callback コールバック関数
 */
export function co_confirmDialogSetFocus(message, focuskey, callback) {

	let buttonList = [
		{'key':DIALOG_BUTTON_LIST_KEY.OK, 'label':'はい'},
		{'key':DIALOG_BUTTON_LIST_KEY.CANCEL, 'label':'いいえ'}
	];

	// メッセージ、ボタン、フォーカス、コールバック関数、メッセージ種類、リンクフラグの設定
	store.commit(STORE_DIALOG_MESSAGE, message);
	store.commit(STORE_DIALOG_BUTTON_LIST, buttonList);
	store.commit(STORE_DIALOG_FOCUS_KEY, focuskey);
	store.commit(STORE_DIALOG_CALL_BACK, callback);
	store.commit(STORE_DIALOG_KIND, DIALOG_KIND.CONFIRM);
	store.commit(STORE_DIALOG_LINK_FLG, false);

	// ダイアログを呼び出す
	store.commit(STORE_DIALOG_DIALOG_FLG, true);
}

/* エラーダイアログ
 * @param {String} message 出力するメッセージ
 * @param {Object} callback コールバック関数
 */
export function co_errorDialog(message, callback) {

	let buttonList = [
		{'key':DIALOG_BUTTON_LIST_KEY.OK, 'label':'はい'}
	];

	// メッセージ、ボタン、フォーカス、コールバック関数、メッセージ種類、リンクフラグの設定
	store.commit(STORE_DIALOG_MESSAGE, message);
	store.commit(STORE_DIALOG_BUTTON_LIST, buttonList);
	store.commit(STORE_DIALOG_FOCUS_KEY, DIALOG_BUTTON_LIST_KEY.OK);
	store.commit(STORE_DIALOG_CALL_BACK, callback);
	store.commit(STORE_DIALOG_KIND, DIALOG_KIND.ALERT);
	store.commit(STORE_DIALOG_LINK_FLG, false);

	// ダイアログを呼び出す
	store.commit(STORE_DIALOG_DIALOG_FLG, true);
}

/* リンク付きエラーダイアログ
 * @param {String} message 出力するメッセージ
 * @param {Object} callback コールバック関数
 */
export function co_errorLinkDialog(message, callback) {

	let buttonList = [
		{'key':DIALOG_BUTTON_LIST_KEY.OK, 'label':'閉じる'}
	];

	// メッセージ、ボタン、フォーカス、コールバック関数、メッセージ種類、リンクフラグの設定
	store.commit(STORE_DIALOG_MESSAGE, message);
	store.commit(STORE_DIALOG_BUTTON_LIST, buttonList);
	store.commit(STORE_DIALOG_FOCUS_KEY, DIALOG_BUTTON_LIST_KEY.OK);
	store.commit(STORE_DIALOG_CALL_BACK, callback);
	store.commit(STORE_DIALOG_KIND, DIALOG_KIND.ALERT);
	store.commit(STORE_DIALOG_LINK_FLG, true);

	// ダイアログを呼び出す
	store.commit(STORE_DIALOG_DIALOG_FLG, true);
}